import { footprintPrice } from "../../../components/store";
import { ShopifyShopSystemStrategy } from "./ShopifyShopSystemStrategy";

export class MicaraaShopSystemStrategy extends ShopifyShopSystemStrategy {
  registerEventHandlers(): void {
    const node = document.querySelector("#mini-cart");
    const observer = new MutationObserver((mutations, observer) => {
      window.dispatchEvent(new CustomEvent("CartReRendered", {}));
    });
    if (node) {
      observer.observe(node, {
        attributes: false,
        childList: true,
        subtree: false,
      });
    }

    window.addEventListener("cart-change", async () => {
      const cart = await this.getCart();
      const offset = this.getOffsetItem(cart);
      if (offset && cart!.items.length === 1) {
        await this.toggleOffset(false, true);
      }
    });

    footprintPrice.subscribe(async (value) => {
      if (value == 0) return;
      const cart = await this.getCart();
      const offset = this.getOffsetItem(cart);
      if (!offset) return;
      // If our price already matches, nothing needs to happen.
      if (offset.price != Math.round(value * 100)) {
        // Refresh if this if the offset is the last item in the cart.
        await this.toggleOffset(false, cart!.items.length === 1);
        if (cart!.items.length > 1) await this.toggleOffset(true);
      }
    });
  }

  async refreshCart(): Promise<void> {
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh"));
  }
}
